import React from "react";

const Link = ({ children, to = "#", ...props }) => {
  return (
    <a href={to} className="text-[#7953D2] underline font-custom" {...props}>
      {children}
    </a>
  );
};

export default Link;
